/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimRewardsResponseDataInner
 */
export interface ClaimRewardsResponseDataInner {
    /**
     * The challenge ID
     * @type {string}
     * @memberof ClaimRewardsResponseDataInner
     */
    challengeId: string;
    /**
     * The challenge specifier
     * @type {string}
     * @memberof ClaimRewardsResponseDataInner
     */
    specifier: string;
    /**
     * The reward amount
     * @type {string}
     * @memberof ClaimRewardsResponseDataInner
     */
    amount?: string;
    /**
     * Transaction signatures
     * @type {Array<string>}
     * @memberof ClaimRewardsResponseDataInner
     */
    signatures?: Array<string>;
    /**
     * Error message if claim failed
     * @type {string}
     * @memberof ClaimRewardsResponseDataInner
     */
    error?: string;
}

/**
 * Check if a given object implements the ClaimRewardsResponseDataInner interface.
 */
export function instanceOfClaimRewardsResponseDataInner(value: object): value is ClaimRewardsResponseDataInner {
    let isInstance = true;
    isInstance = isInstance && "challengeId" in value && value["challengeId"] !== undefined;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;

    return isInstance;
}

export function ClaimRewardsResponseDataInnerFromJSON(json: any): ClaimRewardsResponseDataInner {
    return ClaimRewardsResponseDataInnerFromJSONTyped(json, false);
}

export function ClaimRewardsResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimRewardsResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challengeId': json['challengeId'],
        'specifier': json['specifier'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'signatures': !exists(json, 'signatures') ? undefined : json['signatures'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function ClaimRewardsResponseDataInnerToJSON(value?: ClaimRewardsResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challengeId': value.challengeId,
        'specifier': value.specifier,
        'amount': value.amount,
        'signatures': value.signatures,
        'error': value.error,
    };
}

